import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockMapFrance {
	static init() {

		let blocks = document.querySelectorAll('.block-map-france');
		blocks.forEach( (block) => {

			let map = block.querySelector('.france .svg svg');
			this.pointers = map.querySelectorAll('g');

			// this.pointers.forEach((pointer) => {
			// 	let point = pointer.querySelectorAll(".point");
			// 	let rads = pointer.querySelectorAll(".rad");
			// });
			this.currentPointer = 0;
			this.timeline(this.pointers[this.currentPointer]);
			// let tl = gsap.timeline({
			// 	repeat: -1
			// });
			// tl.to( point, {
			// 	r: 4,
			// 	opacity: 1,
			// 	duration: 0.9
			// });
			// rads.forEach((rad) => {
			// 	tl.to( rad, {
			// 		r: 43,
			// 		opacity: 0,
			// 		duration: 0.9
			// 	}, ">-0.7");
			// });

		});

	}

	static timeline(pointer){
		let point = pointer.querySelectorAll(".point");
		let rads = pointer.querySelectorAll(".rad");
		gsap.set(point, {
			r: 0,
			opacity: 0
		});
		gsap.set(rads, {
			r: 0,
			opacity: 1,
			// webkitFilter:"blur(3px)"
		});
		let tl = gsap.timeline({
			onComplete: () => {
				this.currentPointer++;
				if( this.currentPointer === this.pointers.length ){
					this.currentPointer = 0;
				}
				this.timeline( this.pointers[this.currentPointer] );
			}
		});
		tl.to( point, {
			r: 4,
			opacity: 1,
			duration: 0.5
		});
		rads.forEach((rad) => {
			tl.to( rad, {
				r: 60,
				opacity: 0,
				duration: 1
			}, ">-0.8");
		});
		tl.to( point, {
			r: 0,
			opacity: 0,
			duration: 0.1
		});
	}

}
